const { setCookie, getCookie } = require("../../global/cookie");

const showUpgradeModal = (hide_subtitle = false) => {
  const user = require("../../global/user")
  const app = require("../../global/app");
  const url = require("../../global/url");
  const aiApp = app.aiApp;
  const aiAppName = app.appName;
  setCookie("appurl", aiApp);
  setCookie("app", "pro");
  //
  let wpCta_link = getCookie("regRedirectWP");
  let wp_flow = getCookie("flow");
  // #30066
  let r_flow = getCookie("r_flow");
  if(r_flow){
      switch(r_flow) {
          case 'chatpro':
          case 'chatpdf':
          case 'dreamphoto':
              wpCta_link = '1';
              break;
      }
  }

  // END #30066
  if(wpCta_link && wpCta_link == '1'){
      switch (wp_flow) {
          case '02':
              register_logic_url = '/register-b';
          break;
          case '03':
              register_logic_url = '/register-x';
          break;
          case '04':
              register_logic_url = '/select-account-type-d'; //slash
          break;
          case '05':
              register_logic_url = '/aurora-register'; //slash
          break;
          default:
              register_logic_url = '/register';
      }
  }


  let modalTitleValue = "Switch to PRO";

  // let modatCtaValue = (wpCta_link && wpCta_link == '1') ? url.wp + register_logic_url : url.splash;
  let appDesc = "Switch now to PRO and get access to <span>"+ app.appTotal +"</span> different creativity and productivity AI tools.";
  let titleValue = " to continue using " + aiAppName;
  let userEmail = getCookie("user_email");

  const n_flow = getCookie("n_flow");
  let modatCtaValue;
  
  if (wp_flow === 'chatapp' && n_flow === 'chatapp') {
    modatCtaValue = url.wp + '/pricing-redirect?from=chatapp';
  } else if (n_flow && url.flowUrls[n_flow] && user.is_free_user === true) {
    modatCtaValue = url.flowUrls[n_flow];
  } else if (userEmail) {
    modatCtaValue = url.upgrade;
  } else if (wpCta_link && wpCta_link === '1') {
    modatCtaValue = url.wp + register_logic_url;
  } else {
    modatCtaValue = url.splash;
  }

  const modalsubTitle = document.querySelector('#modal-subtitle');
  const modalTitle = document.querySelector('#modal-title');
  const modalDesc = document.querySelector('#modal-desc');
  const modalCta = document.querySelector('#modal-cta');
  const modalContainer = document.querySelector('#modal-container');
  const modalContent = document.querySelector('#modal-content');

  if(hide_subtitle) {
      modalsubTitle.innerHTML = '';
      modalContainer.classList.add('no-subtitle');
  } else {
      modalContainer.classList.remove('no-subtitle');
      modalsubTitle.innerHTML = "Enjoying the trial version of " + aiAppName + " so far?";
  }
  modalTitle.innerHTML = modalTitleValue + titleValue;
  modalDesc.innerHTML = appDesc;
  modalCta.innerHTML = "CONTINUE";
  modalCta.href = modatCtaValue;

  if (window.self !== window.top) {
      try {
        modalContent.classList.add("limitedUse");
      } catch (error) {
        console.error("Error accessing parent URL: " + error.message);
      }
  }

  modalContainer.style.display = 'block';
};

const showMaxTokenEntUpgradeModal = () => {
  setAppUrl();
  const url = require("../../global/url");
  let modalCtaValue = `${url.wp}/contact-us`;
  let modalTitleValue = "Maximum Token Limit";
  let appDesc = "You've reached the maximum token limit for this month.<br>For continuous access, kindly reach out to our support team.";

  const modalTitle = document.querySelector('#modal-title');
  const modalDesc = document.querySelector('#modal-desc');
  const modalCta = document.querySelector('#modal-cta');
  const modalContainer = document.querySelector('#modal-container');

  modalTitle.innerHTML = modalTitleValue;
  modalDesc.innerHTML = appDesc;
  modalCta.innerHTML = "CONTINUE";
  modalCta.href = modalCtaValue;
  modalContainer.style.display = 'block';
};

const showMaxTokenUpgradeModal = () => {
  setAppUrl();
  const url = require("../../global/url");
  let modalCtaValue = `${url.start}/upgrade/?mx=1`;
  let modalTitleValue = "Maximum Token Limit";
  let appDesc = "You've reached the maximum token limit for this month.<br>Switch now to <span>PRO MAX</span> and get unlimited word responses.";

  const modalTitle = document.querySelector('#modal-title');
  const modalDesc = document.querySelector('#modal-desc');
  const modalCta = document.querySelector('#modal-cta');
  const modalContainer = document.querySelector('#modal-container');

  modalTitle.innerHTML = modalTitleValue;
  modalDesc.innerHTML = appDesc;
  modalCta.innerHTML = "CONTINUE";
  modalCta.href = modalCtaValue;
  modalContainer.style.display = 'block';
};

const showMaxCreditUpgradeModal = () => {
  const url = require("../../global/url");
  let modalCtaValue = `${url.start}/upgrade`;
  let modalTitleValue = "Maximum Prompt Limit";
  let appDesc = "You've reached the maximum prompt limit for this month. Please upgrade to increase your prompt limit.";

  const modalTitle = document.querySelector('#modal-title');
  const modalDesc = document.querySelector('#modal-desc');
  const modalCta = document.querySelector('#modal-cta');
  const modalContainer = document.querySelector('#modal-container');

  modalTitle.innerHTML = modalTitleValue;
  modalDesc.innerHTML = appDesc;
  modalCta.innerHTML = "CONTINUE";
  modalCta.href = modalCtaValue;
  modalContainer.style.display = 'block';
};

const showMonthlyLimitModal = (credits = 80) => {
  let modalCtaValue = `javascript:void(0)`;
  let modalTitleValue = "Maximum Prompt Limit";
  let appDesc = "You've hit your monthly prompt limit. Your " + credits + " credits will replenish next billing cycle. Stay tuned for a new way to top up credits!";

  const modalTitle = document.querySelector('#modal-title');
  const modalDesc = document.querySelector('#modal-desc');
  const modalCta = document.querySelector('#modal-cta');
  const modalContainer = document.querySelector('#modal-container');

  modalTitle.innerHTML = modalTitleValue;
  modalDesc.innerHTML = appDesc;
  modalCta.innerHTML = "CLOSE";
  modalCta.href = modalCtaValue;
  modalCta.addEventListener("click", () => {
    modalContainer.style.display = 'none';
  });
  modalContainer.style.display = 'block';
}

const showMonthlyLimitEntModal = () => {
  const url = require("../../global/url");
  let modatCtaValue = `${url.wp}/contact-us`;
  let modalTitleValue = "Maximum Prompt Limit";
  let appDesc = "You've reached the maximum prompt limit for this month.<br>For continuous access, kindly reach out to our support team.";
  let titleValue = "";

  const modalTitle = document.querySelector('#modal-title');
  const modalDesc = document.querySelector('#modal-desc');
  const modalCta = document.querySelector('#modal-cta');
  const modalContainer = document.querySelector('#modal-container');
  modalContainer.classList.add('max-prompt-limit');

  modalTitle.innerHTML = modalTitleValue + titleValue;
  modalDesc.innerHTML = appDesc;
  modalCta.innerHTML = "CONTINUE";
  modalCta.href = modatCtaValue;
  modalContainer.style.display = 'block';

  addCloseModalButton();
}

const addCloseModalButton = () => {

  if( !document.querySelector('#modal-container .modal-close-container') ) {
    const modalContent = document.querySelector('#modal-content');
    const modalCloseContainer = document.createElement("div");
    modalCloseContainer.classList.add("modal-close-container");
    modalCloseContainer.innerHTML = `<button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>`;

    modalContent.prepend(modalCloseContainer);
    document.querySelector("#modal-container .modal-close-container button").addEventListener("click", function(){
      const modalContainer = document.querySelector('#modal-container');
      modalContainer.style.display = 'none';
      modalCloseContainer.remove();
    });
  }

}

const setAppUrl = () => {
  const app = require("../../global/app");
  const aiApp = app.aiApp;
  setCookie("appurl", aiApp);
}

module.exports = {
  showUpgradeModal,
  showMaxTokenUpgradeModal,
  showMaxTokenEntUpgradeModal,
  showMaxCreditUpgradeModal,
  showMonthlyLimitModal,
  showMonthlyLimitEntModal
};